import { HomeLockIcon } from './HomeLockIcon';

/**
 * author: Nick
 * id ECB8FF23-47EC-4038-9673-1A3A1619C071
 * name home-lock
 * version: 2.3.50
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/home-lock.svg
 * tags
 * - Home Automation 
 * - Lock 
 */
export const HouseSecureIcon = HomeLockIcon;
export default HouseSecureIcon